/** @format */
import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';
import {makeStyles} from '@mui/styles';

export const StyledButtonGroup = styled(Box)(() => ({
  width: '100%',
}));

export const useStyles = makeStyles(theme => ({
  button: {
    ['&.MuiButtonBase-root']: {
      fontSize: '14px',
      borderRadius: 0,
      height: '48px',
      minWidth: 'max-content',
      padding: theme.spacing(4),
      color: theme.palette.text.secondary,
      background: '#F1F1F1',
    },
  },
  selected: {
    ['&.MuiButtonBase-root']: {
      color: '#F1F1F1',
      background: '#547AE0',
    },
  },
  disabledColor: {
    ['&.MuiButtonBase-root']: {
      color: theme.palette.figma_gray_middle_dark?.main,
    },
  },
  disabledBackground: {
    ['&.MuiButtonBase-root']: {
      background: theme.palette.figma_gray_middle_dark?.main,
    },
  },
}));
